import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { getV1ProfilesByProfileIdOptions } from "../../client/@tanstack/react-query.gen";
import { jsonParse } from "../utils/parse";
import type { QueryConfig } from "../utils/query-config";
import { AccountProfile, GetV1LinksByProfileLinkResponse } from "../../client";

// Export the query key creator function
export const getOneProfileQueryKey = (profileId: string) =>
  getV1ProfilesByProfileIdOptions({
    path: { profileID: profileId },
  }).queryKey;

export const getProfileOptions = (profileId: string) =>
  queryOptions({
    ...getV1ProfilesByProfileIdOptions({
      path: { profileID: profileId },
    }),
    staleTime: 0,
  });

export const useGetOneProfile = (profileId: string, config?: QueryConfig) => {
  return useSuspenseQuery({
    ...getProfileOptions(profileId),
    ...config,
    staleTime: 0,
    networkMode: "always",
    select: (data) => jsonParse<AccountProfile>(data),
  });
};
